import { createContext } from 'react'

import { IMetricStats } from '../utils/metric.stats'

export const MetricStatsContext = createContext<IMetricStats>({} as IMetricStats)
